import service from '@/utils/request.js'

export const getList = data => {
  return service({
    method: 'get',
    url: '/Apis/Domain/Record/',
    params: data
  })
}
